import { useInfiniteQuery } from "@tanstack/react-query";
import { getWidgetWantAds } from "@/services/v2/widgetService";

// "Show More" feed for the embed widget; gating is server-side by widgetKey.
const useWidgetWantAds = ({ widgetKey, sortType, enabled = true }) =>
  useInfiniteQuery({
    queryKey: ["widgetWantAds", widgetKey, sortType],
    enabled: !!widgetKey && enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      const res = await getWidgetWantAds(widgetKey, { sortType, page: pageParam });
      return res?.result || { data: [], totalCount: 0 };
    },
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((sum, p) => sum + (p?.data?.length || 0), 0);
      return loaded < (lastPage?.totalCount || 0) ? allPages.length + 1 : undefined;
    },
    select: (result) => ({
      ads: result.pages.flatMap((p) => p?.data || []),
      totalCount: result.pages[0]?.totalCount || 0,
    }),
  });

export default useWidgetWantAds;
